export class tokenObject {
    fullString: string
    constructor(tokenIn:string) {
        this.fullString = tokenIn
    }

    getFullString(){
        return this.fullString;
    }

    getPayload(){
        if(!this.fullString){
           throw new Error("Error: Token is empty") 
        }
        const parts = this.fullString.split('.');
        if (parts.length < 2){
            throw new Error("Error: System can not read the token.")
        }

        // Decode JWT payload
        const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
        const json = decodeURIComponent(
            atob(padded)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        const payload = JSON.parse(json);
        return payload
    }

    getRemainingMs(){
        const payload = this.getPayload();
        const exp = typeof payload.exp === 'number' ? payload.exp : parseInt(payload.exp, 10);
        if (!exp || Number.isNaN(exp)){
            throw new Error("Error: System can not read the time on token.")
        }
        const remainingMs = exp * 1000 - Date.now();
        return remainingMs;
    }

    getRemainingSeconds(){
        return this.getRemainingMs() / 1000;
    }

    getRemainingMinutes(){
        return this.getRemainingMs() / 60000;
    }
}